export default __webpack_public_path__ + "fd2921ee149c7a36b51953231545b871.png";